import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import { getListClassicCart } from "../../../controller/api/__classic__/cart";
import { calculatePage } from "../../../helper/helper";
import Summary from "./partials/Summary";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    dialFrom: "",
    dialTo: "",
    phone: "",
    region: "",
    isDone: undefined,
    page: 0,
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0,
  },
  filterPressCount: 0,
  exportPressCount: 0,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SUBMIT_FILTER":
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0,
        },
        filterPressCount: state.filterPressCount + 1,
      };
    case "UPDATE_DATA":
      return {
        ...state,
        data: {
          ...action.payload,
        },
        isLoading: false,
      };
    case "UPDATE_PAGE":
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload,
        },
      };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const OrderPage = () => {
  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(["lottmekong"]);

  const getAllFunc = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });

    const query = {
      from: state.filter.from,
      to: state.filter.to,
      phone: state.filter.phone,
    };

    if (state.filter.isDone !== undefined) {
      query.isDone = state.filter.isDone;
    }

    if (state.filter.region !== "") {
      query.region = state.filter.region;
    }

    if (state.filter.dialFrom) {
      query.dialFrom = state.filter.dialFrom;
    }

    if (state.filter.dialTo) {
      query.dialTo = state.filter.dialTo;
    }

    try {
      const response = await getListClassicCart(
        cookies.lottmekong,
        query,
        state.filter.page
      );

      if (response) {
        const res = {
          list: response.data,
          total: response.total,
          totalPage: calculatePage(response.total),
        };
        dispatch({
          type: "UPDATE_DATA",
          payload: res,
        });
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, [
    cookies.lottmekong,
    state.filter.from,
    state.filter.to,
    state.filter.dialFrom,
    state.filter.dialTo,
    state.filter.page,
    state.filter.phone,
    state.filter.isDone,
    state.filter.region,
  ]);

  useEffect(() => {
    getAllFunc();
  }, [getAllFunc, state.filterPressCount, state.filter.page]);

  useEffect(() => {
    document.title = "Đơn hàng";
  }, []);

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <div className="py-4" style={{ position: "relative" }}>
        {state.isLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              minHeight: "400px",
            }}
          >
            <div className="text-center">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3 fw-bold text-primary">Đang tải dữ liệu...</div>
            </div>
          </div>
        )}

        <FilterForm />

        <Summary />

        <Table />
      </div>
    </Context.Provider>
  );
};

export default OrderPage;
